import React, { memo, useState } from "react";

import Portal from "shared/components/Portal";
import { ModalContent, Overlay } from "./assets/style";
import { ModalFocusRoot } from "components/ModalFocusRoot";
import { InteractiveFocusScope } from "components/InteractiveFocusScope";


interface ModalProps {
  children: React.ReactNode;
  onHide: VoidFunction;
  modalContentClass?: string;
  allowBackdropClick?: boolean;
  modalBackground?: string;
  isVisible?:boolean;
  isPartial?: boolean;
  zIndex?: number;
  zIndexOverlay?: number;
  ariaLabel?: string;
}


const Modal = ({
  children,
  onHide,
  allowBackdropClick = true,
  modalContentClass = "",
  modalBackground = "#fff",
  isVisible,
  isPartial,
  zIndex,
  zIndexOverlay,
  ariaLabel = "Modal Dialog",
}: ModalProps) => {
  const [isHidden, setIsHidden] = useState(isVisible);

  const hide = () => {
    setIsHidden(true);
    onHide();
  };
  const modalCustomClass = `${modalContentClass} ${isPartial ? "partial-modal" : ""} `;
  const overlayClass = isHidden ? "" : "hide-overlay";

  const backdropClick = allowBackdropClick ? hide : () => { };
  //TODO mukesh add overflow hidden on body when modal open
  return (
    <Portal>
      <InteractiveFocusScope>
      <ModalFocusRoot ariaLabel={ariaLabel}>
      <ModalContent
        className={modalCustomClass}
        background={modalBackground}
        zIndex={zIndex}
      >
        {children}
      </ModalContent>
      </ModalFocusRoot>
      <Overlay
        className={overlayClass}
        onClick={backdropClick}
        zIndex={zIndexOverlay}
      />
      </InteractiveFocusScope>
    </Portal>
  );
};

export default memo(Modal);
